/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { fileModelSchema } from "./fileModelSchema.ts";
import { z } from "zod";

export const policyModelSchema = z.object({
    "languageCode": z.string().describe("Код языка"),
"file": z.lazy(() => fileModelSchema).describe("Файл")
    })